import { render } from "./EventCalender.vue?vue&type=template&id=c9260b8e&scoped=true&ts=true"
import script from "./EventCalender.vue?vue&type=script&lang=ts"
export * from "./EventCalender.vue?vue&type=script&lang=ts"

import "./EventCalender.vue?vue&type=style&index=0&id=c9260b8e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9260b8e"]])

export default __exports__